import React, {Fragment,useEffect, useState } from 'react';
import { useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';
import auth from '../../../helpers/auth';
import config from '../../../config';
import Spinner from '../../../components/Spinner/Spinner';

const CheckoutForm = ({ selectedSlots, quantity, targetPackage, showPaymentMessage, closePaymentModal }) => {
	const stripe = useStripe();
	const elements = useElements();
	const [ isLoder, setIsLoader ] = useState(false);

  useEffect(()=>{
    console.log(targetPackage,"targetPackage");
  })
	const handleSubmit = async (event) => {
		// We don't want to let default form submission happen here,
		// which would refresh the page.
		event.preventDefault();

		if (!stripe || !elements) {
			// Stripe.js hasn't yet loaded.
			// Make sure to disable form submission until Stripe.js has loaded.
			return;
		}
		await setIsLoader(true);
		const result = await stripe.confirmPayment({
			//`Elements` instance that was used to create the Payment Element
			elements,
			confirmParams: {
				return_url: 'http://localhost:3000/listing/146/newlist/'
			},
			redirect: 'if_required'
		});

		if (result.error) {
			// Show error to your customer (for example, payment details incomplete)
			//console.log(result.error.message,"errorrrrrrrrr");
			//await setPaymentMessage(result.error.message);
      await setIsLoader(false);
      showPaymentMessage(false, result.error.message);
		} else {
			//console.log(result,"result");
			// Your customer will be redirected to your `return_url`. For some payment
			// methods like iDEAL, your customer will be redirected to an intermediate
			// site first to authorize the payment, then redirected to the `return_url`.
			//console.log(result.paymentMethod.id,"result");
			let data = {
				param: {
					counsellor_id: targetPackage.user_id,
					package_id: targetPackage.id,
					notes: '',
					token: result.paymentIntent.id,
					amount: targetPackage.no_of_slots > 1 ? targetPackage.amount : targetPackage.amount * quantity,
					selected_slots: selectedSlots,
					connect_id: targetPackage.stripe_connect.stripe_id
				}
			};
      //console.log(data,"data");
			saveBooking(data);
		}
	};

	const saveBooking = async (data) => {
		let authToken = auth.getAccessToken();
		let result = await fetch(`${config.__API__}/make/booking`, {
			method: 'POST',
			body: JSON.stringify(data),
			headers: {
				'Content-Type': 'application/json; charset=utf-8',
				Accept: 'application/json',
				Authorization: `Bearer ` + authToken
			}
		});
		let response = await result.json();
		if (response.success) {
			await setIsLoader(false);
      showPaymentMessage(true, 'Your booking has been successful!');
		} else {
			await setIsLoader(false);
      showPaymentMessage(false, 'Opps! Something went wrong try later');
		}
   
	};

	return (
		<Fragment>
			<div className="modal opacity fixed h-full top-0 left-0 right-0 flex items-center justify-center z-10">
				<div className="modal-overlay absolute w-full h-full bg-gray-900 opacity-75" />
				<div className="modal-container bg-white w-11/12 md:w-8/12 mx-auto rounded shadow-lg z-50 overflow-y-auto">
					<div className="modal-content p-6 text-center slot_booking">
          <div className='blogo'>
            <img
                className="w-full"
                src="images/new-web-logo.png"
                alt="Site Logo"
              />
            </div>
						<div className="flex justify-end pb-3 closePaymentModal">
							<div
								className="modal-close cursor-pointer z-50"
								onClick={() => {
									closePaymentModal();
								}}
							>
								<svg
									className="fill-current text-black"
									xmlns="http://www.w3.org/2000/svg"
									width={18}
									height={18}
									viewBox="0 0 18 18"
								>
									<path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z" />
								</svg>
							</div>
						</div>
						<div className="modal__body text-center">
							<div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4 mt-5">
								<div className="sm:flex sm:items-start">
									<div className="text-center sm:mt-0 sm:ml-4">
										<div className="mt-2" />
										<div className="booking_page--page">
											<form onSubmit={handleSubmit}>
												<PaymentElement />
												{isLoder ? (
													<Spinner />
												) : (
													<button disabled={!stripe} className="bg_blue text-white">
														Pay Now
													</button>
												)}
											</form>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</Fragment>
	);
};

export default CheckoutForm;



// WEBPACK FOOTER //
// ./src/routes/Checkout/components/CheckoutForm.js